<template>
  <app-modal v-model="isDialogOpened"
             size="md"
             :ok-text="$t('common.confirm')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.question-answer.QuestionAnswerItemCloseQuestionDialog.title') }}</template>

    <template #body>{{ $t('project.question-answer.QuestionAnswerItemCloseQuestionDialog.body') }}</template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'QuestionAnswerItemCloseQuestionDialog',
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
